import { Component, QueryList } from "@angular/core";
import { AfterViewInit } from "@angular/core";
import { YouTubePlaylistComponent } from "@app/components/platform/youtube-playlist.component";
import { ViewChildren } from "@angular/core";

@Component({
  templateUrl: "./tutorial-videos.component.html",
})
export class TutorialVideosComponent {
  tutorials = [
    {
      title: "Catalog Maker",
      playlistId: "PLN-24rcPokNRuri4YCfJVy1EugaDn1OfG",
    },
    {
      title: "Order Sheet",
      playlistId: "PLN-24rcPokNQ36udnWbQY0JvZuSkannk5",
    },
    {
      title: "Tear Sheet",
      playlistId: "PLN-24rcPokNQ8LhfouALPxjaE53d16qK4",
    },
    {
      title: "Barcode Label",
      playlistId: "PLN-24rcPokNQj81NYngap3Qd2q0tSm9BI",
    },
    {
      title: "Flipbook",
      playlistId: "PLN-24rcPokNSnXobMLk5jx33BQjrP0BLL",
    },
  ];

  filter: string = "";

  @ViewChildren(YouTubePlaylistComponent)
  youtubePlaylistComponents: QueryList<YouTubePlaylistComponent>;
}
